const TRANSFORMER_MAX_MOBILE_WIDTH_PX = 767;
const TRANSFORMER_MIN_DESKTOP_WIDTH_PX = 768;
const DEFAULT_IMAGE_URL = 'https://s1.pclncdn.com/design-assets/brand-assets/default_image.jpeg';
export { DEFAULT_IMAGE_URL, TRANSFORMER_MAX_MOBILE_WIDTH_PX, TRANSFORMER_MIN_DESKTOP_WIDTH_PX };
